module.exports = __webpack_public_path__ + "img/Warrior-orc-f-70.198a4293.gif";